export default "__VITE_ASSET__BYcn7i0b__"